import React from 'react';
import { motion } from 'framer-motion';
const testimonios = [{
  initials: 'LR',
  quote: 'Aprobé Macro con 8 cuando el promedio de la comisión fue 5.8. Estudié la mitad.',
  author: 'Lucía R. · Economía UBA · 3er año'
}, {
  initials: 'MS',
  quote: 'Tenía 4 materias juntas y estaba al borde del colapso. Aprobé 3 de 4 ese cuatrimestre.',
  author: 'Mateo S. · Ingeniería UTN · 2do año'
}, {
  initials: 'VM',
  quote: 'Soy de las que estudian mucho y les va más o menos. Este cuat saqué el mejor promedio desde que entré a la carrera.',
  author: 'Valentina M. · Psicología UBA · 4to año'
}];
export function Testimonios() {
  return <section className="bg-[#0C1220] py-[60px] md:py-[80px]" data-id="element-248">
      <div className="max-w-[1000px] mx-auto px-5" data-id="element-249">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-250">
          {testimonios.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-2 border border-brand-blue-dark rounded-xl p-6 flex flex-col" data-id="element-251">
              <div className="flex items-center gap-3 mb-4" data-id="element-252">
                <div className="w-10 h-10 rounded-full bg-brand-blue flex items-center justify-center text-white font-bold text-sm shrink-0" data-id="element-253">
                  {t.initials}
                </div>
                <div className="text-brand-gold tracking-[2px] text-sm" data-id="element-254">
                  ★★★★★
                </div>
              </div>
              <p className="text-[15px] italic text-white mb-4 leading-[1.6] flex-grow" data-id="element-255">
                "{t.quote}"
              </p>
              <p className="text-[13px] text-brand-gray font-medium" data-id="element-256">
                — {t.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}